export const defaultColors = {
  pink900: '#DE0C4B',
  pink800: '#FF5776',
  blue900: '#000B3C',
  blue800: '#323B69',
  blue700: '#0086CB',
  blue600: '#5CB5FE',
  blueLight: '#E9EDFF',
  bluePrimary: '#2647D7',
  bluePrimaryLight: '#D4DAF7',
  bluePrimaryDark: '#00198A',
  blueSecundary: '#1833AC',
  blueSecundaryLight: '#B5C0F5',
  blueSecundaryDark: '#7D91ED',
  yellow900: '#FCCC00',
  yellow800: '#FFFF50',
  lilac900: '#7A1FA0',
  lilac800: '#AD52D2',
  purple900: '#6600F7',
  purple800: '#A248FF',
  grey600: '#B0AFAF',
  grey500: '#CFCFCF',
  grey400: '#FFFFFF',
  green100: '#89D747',
  greyPrimary: '#575757',
  greyNeutral: '#767676',
  greyLight: '#CFCFCF',
  red100: '#DD4646',
  red200: '#FF5776',
  red300: '#B30142',
  white100: '#FFFFFF',
}

export const sanarColors = {
  ...defaultColors,
  // bluePrimary: '#F56B00',
  // bluePrimaryDark: '#D35C00',
  // blueSecundary: '#FFD9BC',
  // blueSecundaryDark: '#F4BD92',
}
